import React, { useState } from 'react'
import { Modal } from '@amzn/storm-ui'
import { LaunchModalContainer, HeaderContainer, AdvertisingLogoContainer, Headline, CloseButton, CloseIcon, CarouselContainer, CarouselSlideContainer } from './style'
import Carousel from './Carousel'
import { useEmitInitialRender } from '../../../utils/hooks'
import { LaunchModalProps } from '..'
import { dismissWidget } from '../../../utils/functions'
import { WidgetTypes } from '../../../common/constants'

export const DesktopLaunchModal: React.VFC<LaunchModalProps> = ({
  closeButtonText = 'Close',
  previousButtonText = 'previous',
  nextButtonText = 'next',
  playButtonText = 'play',
  pauseButtonText = 'pause',
  anchorId,
  slides,
  slidesDuration,
  message,
  logo,
  imageSize = 'medium',
  dataTaktId,
}) => {
  useEmitInitialRender(WidgetTypes.DesktopLaunchModal)

  const [isOpen, setIsOpen] = useState(true)
  const onModalClose = () => {
    dismissWidget(anchorId)
    setIsOpen(false)
  }

  return (
    <Modal data-takt-id={dataTaktId} isOpen={isOpen} onClose={onModalClose} hasCloseButton={false} padding="none" modalElementId="AACChromePortal">
      <LaunchModalContainer size={imageSize}>
        <HeaderContainer>
          {logo && <AdvertisingLogoContainer src={logo.link} alt={logo.altText} />}
          <Headline type="h1" color="primary">
            {message}
          </Headline>
          <CloseButton onClick={onModalClose} aria-label={closeButtonText} data-ccx-e2e-id="aac-ftu-modal-close" data-takt-id={`${dataTaktId}_close-button`}>
            <CloseIcon type="times" />
          </CloseButton>
        </HeaderContainer>
        <CarouselContainer>
          <CarouselSlideContainer>
            <Carousel
              ariaLabels={{
                previous: previousButtonText,
                next: nextButtonText,
                play: playButtonText,
                pause: pauseButtonText,
              }}
              slides={slides}
              slidesDuration={slidesDuration}
              imageSize={imageSize}
              dataTaktId={dataTaktId}
            />
          </CarouselSlideContainer>
        </CarouselContainer>
      </LaunchModalContainer>
    </Modal>
  )
}
